import { createDraftSafeSelector } from "@reduxjs/toolkit"

export const selectCadastralData = state => state.cadastralData

export const selectCadastralDataFormVisibility = createDraftSafeSelector(
  [selectCadastralData],
  cadastralData => cadastralData.cadastralDataFormVisibility
)